module.exports = __webpack_public_path__ + "05_mole.4dbc4fe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer2/05_mole.png
// module id = qOMv
// module chunks = 0